import { Component, Vue, Prop } from 'vue-property-decorator';
import { Field, TextField, Btn, FormButtonDisabler, IModalComponent, Validations } from '@samc/centricity-core';
import { ITradingProduct } from '@/Interfaces';

@Component({
  name: 'trading-product-form-modal',
  components: { Field, TextField, Btn, FormButtonDisabler }
})
export default class TradingProductFormModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<ITradingProduct | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public cusip: string = '';
  public description: string = '';
  public showValidations: boolean = false;
  public get validations(): Validations<ITradingProduct> {
    let result: any = {}
    if (this.cusip.length == 0) {
      result.name = 'CUSIP is required!';
    }

    return result;
  }

  public mounted() {
    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        return {
          cusip: this.cusip,
          description: this.description
        } as ITradingProduct
      }
    });
  }
}